import { BACKEND_URL } from "../../common/constants";

export const authorize = async (navigator, pathname) => {
  const response = await fetch(`${BACKEND_URL}/auth/authorize`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  if (response.status === 401) {
    if (!pathname.includes("/login")) navigator("/login");
  } else if (response.status === 200) {
    const user = await response.json();
    if (pathname.includes("/app" && user.role === "client"))
      navigator("/login");
    if (!pathname.includes("/app") && user.role === "admin")
      navigator("/app/category");
  }
};
